import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { COLOR_PICKER_LAYOUTS } from "./constants";

export const colorPickerDataSchema = z.object({
  value: z.string().optional(),
  swatches: z.string().optional(),
  size: z.enum(SIZES).optional(),
  layout: z
    .enum(COLOR_PICKER_LAYOUTS)
    .optional()
    .describe(
      '"swatch" shows the color alone, a square the height of a field, with no field around it.',
    ),
  ariaLabel: z.string().optional(),
  swatchesOnly: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false")
    .describe(
      "Shows the swatch grid alone, without the area and slider; picking a swatch closes the popup.",
    ),
  wheel: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  arrow: z
    .string()
    .optional()
    .transform((value) =>
      value === undefined ? undefined : value !== "false",
    ),
});

export type ColorPickerDataProps = z.infer<typeof colorPickerDataSchema>;
